export const SHIFT_TYPE_VALUES = ["full_time", "morning", "evening", "night"];

const readNodeAttr = (node, key) => node?.[key] ?? node?.attributes?.[key];

export const getShiftOptions = (labels) =>
  labels.shiftOptions.map((option) => ({
    id: option.value,
    name: option.label,
  }));

export const getShiftOptionLabel = (sharedLabels, shiftType) => {
  if (!shiftType) return "";

  return sharedLabels?.shiftTypes?.[shiftType] || "";
};

export const getLocalizedShiftName = (shift = {}, lang = "en", sharedLabels = {}) => {
  const shiftType = readNodeAttr(shift, "shift_type");
  if (shiftType) {
    const label = getShiftOptionLabel(sharedLabels, shiftType);
    if (label) return label;
  }

  const englishName =
    readNodeAttr(shift, "name_en") || readNodeAttr(shift, "name") || "";
  const arabicName = readNodeAttr(shift, "name_ar");

  if (lang === "ar") {
    if (arabicName?.trim()) return arabicName.trim();
    if (englishName && sharedLabels?.shiftTypes?.[englishName]) {
      return sharedLabels.shiftTypes[englishName];
    }
  }

  return englishName.replace(/_/g, " ") || "";
};

export const hasAvailableShiftType = (shifts = []) => {
  const selectedShiftTypes = shifts
    .map((shift) => shift.shift_type)
    .filter(Boolean);

  return SHIFT_TYPE_VALUES.some(
    (shiftType) => !selectedShiftTypes.includes(shiftType),
  );
};
